import { formatDateTime } from '@juvare/common-web-ui/utils';
export const useAccountFormatters = () => {
    return {
        lastLogin: (key, oldValue, newValue) => formatDates(key, oldValue, newValue),
    };
};
const formatDates = (key, oldValue, newValue) => (Object.assign(Object.assign(Object.assign({}, (key && { key })), (typeof oldValue === 'number' && !isNaN(oldValue) && { oldValue: formatDateTime(new Date(oldValue)) })), (typeof newValue === 'number' && !isNaN(newValue) && { newValue: formatDateTime(new Date(newValue)) })));
